<template>
  <el-dialog
    title="編輯錄音流通成員"
    fullscreen
    @close="handleDlgClose"
    :visible.sync="innerVisible"
  >
    <div class="container" v-loading="isLoading">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="關鍵字">
              <el-input
                v-model="queryForm.qstr"
                size="small"
                placeholder="編號、班名、名稱、序號、備註"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-button
            type="primary"
            @click="handleBatchJoin"
            size="small"
            :disabled="selectedRow.length === 0"
            >批次加入錄音流通</el-button
          >

          <el-button
            type="danger"
            @click="handleBatchQuit"
            size="small"
            :disabled="selectedRow.length === 0"
            >批次移出錄音流通</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-library-building" /> 錄音流通：{{ recshareName }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            v-loading="isLoading"
            ref="dataTable"
            :data="members"
            @sort-change="sortChange"
            :default-sort="{ prop: defaultSortCol, order: defaultOrder }"
            @selection-change="handleSelectionChange"
            stripe
            style="width: 100%"
          >
            <el-table-column type="selection" width="45"> </el-table-column>

            <el-table-column
              prop="id"
              type="index"
              :index="indexFormatter"
              fixed
            >
            </el-table-column>

            <el-table-column
              label="人員編號"
              prop="no"
              sortable="custom"
              width="150"
            >
            </el-table-column>
            <el-table-column
              label="班級名稱"
              prop="className"
              sortable="custom"
              width="150"
            >
            </el-table-column>

            <el-table-column
              label="月光機序號"
              prop="moonlight2SerialNumber"
              sortable="custom"
              width="200"
            >
            </el-table-column>
            <el-table-column
              label="人員名稱"
              prop="name"
              sortable="custom"
              width="150"
            >
            </el-table-column>

            <el-table-column label="備註" prop="memo" width="180">
            </el-table-column>

            <el-table-column label="加入錄音流通" width="140">
              <template #default="scope">
                <el-switch
                  :value="isRecshareMbr(scope.row)"
                  active-text="是"
                  inactive-text="否"
                  :disabled="isSwitchDisabled(scope.$index)"
                  v-loading="isSwitchDisabled(scope.$index)"
                  @change="
                    (isMember) => setMember(isMember, scope.row, scope.$index)
                  "
                >
                </el-switch>
              </template>
            </el-table-column>

            <el-table-column label="允許上傳檔案">
              <template #default="scope">
                <el-switch
                  v-if="isRecshareMbr(scope.row)"
                  :value="isUploadable(scope.row)"
                  active-text="是"
                  inactive-text="否"
                  :disabled="!isRecshareMbr(scope.row) || isSwitchDisabled(scope.$index)"
                  v-loading="isSwitchDisabled(scope.$index)"
                  @change="
                    uploadable =>
                      changeIsUploadable(uploadable, scope.row, scope.$index)
                  "
                >
                </el-switch>
              </template>
            </el-table-column>

          </el-table>
        </CRow>

        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>
      </CCardBody>
    </CCard>

    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">關閉</el-button>
    </template>
  </el-dialog>
</template>

<script>
import API from "@/api/";
import { mapGetters } from "vuex";
export default {
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    recshareId: {
      type: Number,
      default: null,
    },
    recshareName: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      myownOrg: "auth/orgName",
      members: "member/members",
      total: "member/total",
      offset: "member/offset",
      sort: "member/sort",
      order: "member/order",
    }),
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    return {
      defaultSortCol: "id",
      defaultOrder: 'ascending',
      isLoading: false,
      disabledSwitchIdx: [],
      formLabelWidth: "100px",
      pageSize: 50,
      currentPage: 1,
      selectedRow: [],
      queryForm: {
        qstr: "",
      },
      activeQueryForm: {
        qstr: "",
      },
    };
  },
  created() {
    this.$store.commit("member/CLEAR");
    this.$store.commit("member/SET_SORT", this.defaultSortCol);
    this.$store.commit("member/SET_ORDER", this.defaultOrder);
    if (this.innerVisible) {
      //NOTE: always start from the first page
      this.query(this.pageSize, 0, this.sort, this.order);
    }
  },
  methods: {
    changeIsUploadable(uploadable, mbr, index) {
      const isChecked = this.selectedRow.find(row => row.name === mbr.name);
      let p;
      this.disabledSwitchIdx.push(index);
      if (uploadable) {
        p = this.setUploable(true, mbr, index);
      } else {
        p = this.setUploable(false, mbr, index);
      }
      p.finally(() => {
        isChecked &&
          this.$refs.dataTable.toggleRowSelection(this.channels[index], true);

        const found = this.disabledSwitchIdx.indexOf(index);
        found !== -1 && this.disabledSwitchIdx.splice(found, 1);
      });
    },

    setUploable(uploadable, mbr, index, updateStore = true, showMsg = true) {
      const params = {};
      params.isUploadable = uploadable;
      return API.recshareMember.update(mbr.recShareMembers[0].id, params).then(res => {
        if (updateStore) {
          const newMbr = { ...mbr };
          const recShareMembers = [{
            id: res.data.id,
            isUploadable: uploadable,
          }];
          newMbr.recShareMembers = recShareMembers;

          const payload = {};
          payload.newMbr = newMbr;
          payload.index = index;
          this.$store.commit("member/CHANGE_MEMBER", payload);
        }

        showMsg &&
          this.$message({
            type: "success",
            message: "上傳權限設定成功!",
          });
      });
    },



    isUploadable(mbr) {
      return (mbr.recShareMembers.length > 0) && mbr.recShareMembers[0].isUploadable; 
    },

    isSwitchDisabled(idx) {
      return this.disabledSwitchIdx.includes(idx);
    },

    batchHandler(isSkipped, actionFunc, successMsg) {
      let promises = [];
      this.isLoading = true;
      let runningItem = [];
      let failedItem = [];
      this.selectedRow.forEach((row) => {
        if (!isSkipped(row)) {
          runningItem.push(row);
          promises.push(actionFunc(row, null, false, false));
        }
      });

      Promise.allSettled(promises)
        .then((results) => {
          results.forEach((res, idx) => {
            //if (res.status === "fulfilled") {
            //this.$refs.dataTable.toggleRowSelection(this.members[selectedIdx[idx]], false);
            //}
            if (res.status === "rejected") {
              //console.log(`rejected: pushed name = ${runningItem[idx].name}`);
              failedItem.push(runningItem[idx].name);
              //this.$refs.dataTable.toggleRowSelection(this.members[selectedIdx[idx]], true);
            }
          });

          //console.log(`failedItem = ${JSON.stringify(failedItem)}`);
          if (!failedItem.length) {
            this.$message.success(successMsg);
          } else {
            this.$message.error("部分項目發生錯誤!");
          }
        })
        .finally(() => {
          this.query(
            this.pageSize,
            this.offset,
            this.sort,
            this.order,
            this.activeQueryForm
          ).then(() => {
            failedItem.forEach((failedName) => {
              const failedOne = this.members.find(
                (mbr) => mbr.name === failedName
              );
              failedOne &&
                this.$refs.dataTable.toggleRowSelection(failedOne, true);
            });
            //NOTE: we intentionally set loading to false ONLY when query succeeds
            this.isLoading = false;
          });
        });
    },

    handleBatchJoin() {
      const isSkipped = (row) => (this.isRecshareMbr(row) ? true : false);
      this.batchHandler(isSkipped, this.joinRecshare.bind(this), "批次加入成功");
    },
    handleBatchQuit() {
      const isSkipped = (row) => (!this.isRecshareMbr(row) ? true : false);
      this.batchHandler(isSkipped, this.quitRecshare.bind(this), "批次移出成功");
    },

    handleSelectionChange(rows) {
      //console.log(`handleSelectionChange: val = ${JSON.stringify(rows)}`);
      this.selectedRow = rows;
    },

    setMember(isMember, usr, index) {
      const isChecked = this.selectedRow.find((row) => row.name === usr.name);
      let p;
      this.disabledSwitchIdx.push(index);
      if (isMember) {
        p = this.joinRecshare(usr, index);
      } else {
        p = this.quitRecshare(usr, index);
      }
      p.finally(() => {
        isChecked &&
          this.$refs.dataTable.toggleRowSelection(this.members[index], true);

        const found = this.disabledSwitchIdx.indexOf(index);
        found !== -1 && this.disabledSwitchIdx.splice(found, 1);
      });
    },
    isRecshareMbr(usr) {
      return usr.recShareMembers.length > 0 ? true : false;
    },

    joinRecshare(mbr, index, updateStore = true, showMsg = true) {
      const params = {};
      params.recshareId = this.recshareId;
      params.memberId = mbr.id;
      params.isUploadable = false;
      return API.recshareMember.add(params).then((res) => {
        //console.log(`joinRecshare: then, res = ${JSON.stringify(res)}`);
        //console.log(`joinRecshare: then, `);
        if (updateStore) {
          const newMbr = { ...mbr };
          const recShareMembers = [{}];
          recShareMembers[0].id = res.data.id;
          recShareMembers[0].isUploadable = false;
          newMbr.recShareMembers = recShareMembers;

          const payload = {};
          payload.newMbr = newMbr;
          payload.index = index;
          this.$store.commit("member/CHANGE_MEMBER", payload);
        }

        showMsg &&
          this.$message({
            type: "success",
            message: "加入成功!",
          });
        return res;
      });
    },

    quitRecshare(mbr, index, updateStore = true, showMsg = true) {
      return API.recshareMember.remove(mbr.recShareMembers[0].id).then((res) => {
        if (updateStore) {
          const newMbr = { ...mbr };
          newMbr.recShareMembers = [];

          const payload = {};
          payload.newMbr = newMbr;
          payload.index = index;
          this.$store.commit("member/CHANGE_MEMBER", payload);
        }

        showMsg &&
          this.$message({
            type: "success",
            message: "移除成功!",
          });
        return res;
      });
    },

    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.activeQueryForm = { ...queryForm };
      this.query(this.pageSize, 0, this.sort, this.order, this.activeQueryForm);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.activeQueryForm);
    },
    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    query(max, offset, sort, order, params = {}) {
      return this.$store
        .dispatch("member/list", {
          recshare: this.recshareId,
          max: max,
          offset: offset,
          sort,
          order,
          ...params,
        })
        .finally(() => {
          this.disabledSwitchIdx = [];
        });
    },
    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("member/SET_SORT", this.defaultSortCol);
        this.$store.commit("member/SET_ORDER", this.defaultOrder);
      } else {
        this.$store.commit("member/SET_SORT", args.prop);
        this.$store.commit("member/SET_ORDER", args.order);
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    handleDlgClose() {
      this.$store.dispatch("recshareMember/list", null);
    },
  },
};
</script>

<style></style>
